import { gql } from "@apollo/client";
import { parsedCurrency } from "../../../../utils/mathUtils";

const CREATE_HONORARIO = gql`
    mutation createHonorarioProfesional($input: AddHonorarioInput!){
        createHonorarioProfesional(input: $input) {
              success,
              error,
              valorEsperado
        }
    }
`;

export default CREATE_HONORARIO;

export const adaptAddHonorarioInput = (data, esEnfermeria) => {
  const {
    id,
    cambioSonda,
    capacitacion,
    emergencia,
    extraduracion,
    valor,
    valorVirtual,
    valorExtra,
    ...restData
  } = data;

  return {
    ...restData,
    valor: parsedCurrency(valor),
    valorVirtual: parsedCurrency(valorVirtual),
    valorExtra: parsedCurrency(valorExtra),
    ajustesEnfermeria: esEnfermeria ? [
    { idTipoAjusteEnfermeria: 1, valor: parsedCurrency(cambioSonda) },
    { idTipoAjusteEnfermeria: 2, valor: parsedCurrency(capacitacion) },
    { idTipoAjusteEnfermeria: 3, valor: parsedCurrency(emergencia) },
    { idTipoAjusteEnfermeria: 4, valor: parsedCurrency(extraduracion) }] :
    null
  };
};